import angular from 'angular';

import '@client/core/config';

import { ReschedulePickup } from './ReschedulePickup.resource';

angular
  .module('app.global.reschedule-pickup', ['core.config'])
  .factory('ReschedulePickup', ReschedulePickup);
